// shapeTypes.js
export const ShapeType = {
  NONE: 'none',
  LINE: 'line',
  CIRCLE: 'circle',
  POLYGON: 'polygon',
  POLYLINE: 'polyline',
};

